import { apiClient } from "../apiClient";

// Podgląd rabatu w checkoucie — NIE jest autorytatywny, backend przelicza kwotę ponownie przy tworzeniu zamówienia.
const validate = ({ eventId, code, items }) =>
    apiClient.post(`/events/${eventId}/discount-codes/validate`, {
        code,
        items,
    }).then(r => r.data);

export default {
    validate,
};
